// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Qthn","title":"Header_title__iVoFU","side":"Header_side__3gCdJ"};